import { useCallback, useEffect, useRef, useState } from "react";
import { auth } from "../firebase";
import { enviarCodigoConfirmacao, confirmarCodigoEmail } from "../utils/printControlAuth";
import { AuthLayout } from "./AuthLayout";
import { CadastroOtpAnim } from "./CadastroOtpAnim";

/* Conta que entrou com o e-mail ainda não confirmado: o painel só abre depois
   do código de 6 dígitos enviado ao e-mail da conta (uma vez por conta; quem
   entra com Google já chega confirmado, e quem acabou de confirmar no cadastro
   não recebe outro código). */

function mensagem(erro) {
  const code = String(erro?.code || "");
  if (code.includes("resource-exhausted")) return "Muitos códigos pedidos. Aguarde alguns minutos e tente de novo.";
  if (code.includes("unauthenticated")) return "Sua sessão expirou. Saia e entre de novo.";
  if (code.includes("network") || code.includes("unavailable") || code.includes("internal")) return "Não foi possível enviar o código agora. Confira sua internet e tente de novo.";
  return erro?.message || "Não foi possível enviar o código. Tente de novo.";
}

export function ConfirmarEmailConta({ email, onConfirmado, onSair }) {
  const [fase, setFase] = useState("enviando"); // enviando | codigo | erro
  const [erro, setErro] = useState("");
  const iniciou = useRef(false);

  const enviar = useCallback(async () => {
    const r = await enviarCodigoConfirmacao(auth);
    if (r.confirmado) { onConfirmado(); return; }
    setFase("codigo");
  }, [onConfirmado]);

  const tentar = useCallback(() => {
    setFase("enviando"); setErro("");
    enviar().catch(e => { setErro(mensagem(e)); setFase("erro"); });
  }, [enviar]);

  // Manda o código ao abrir (uma vez; o servidor também segura pedidos repetidos)
  useEffect(() => {
    if (iniciou.current) return;
    iniciou.current = true;
    tentar();
  }, [tentar]);

  const verificar = useCallback(codigo => confirmarCodigoEmail(auth, codigo), []);
  const reenviar = useCallback(async () => {
    try { await enviarCodigoConfirmacao(auth); }
    catch (e) { throw new Error(mensagem(e)); }
  }, []);

  return <AuthLayout title="Confirme seu e-mail" subtitle="Para proteger sua conta, confirme que este e-mail é seu. É só uma vez." footer={<button type="button" className="auth-link" onClick={onSair}>Sair e entrar com outra conta</button>}>
    {fase === "enviando" && <p className="auth-notice" role="status">Enviando o código…</p>}
    {fase === "erro" && <div className="auth-feedback" role="alert">{erro}<div><button type="button" onClick={tentar} className="auth-link">Tentar de novo</button></div></div>}
    {fase === "codigo" && <div className="auth-verification"><CadastroOtpAnim email={email} onVerify={verificar} onResend={reenviar} onAdvance={onConfirmado} /></div>}
  </AuthLayout>;
}
